import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetDeductionByPayrollResultId } from '../../../../../../../reduxToolkit/PayrollPolicy/PayrollPolicyApi';
import { IconGraphDown } from '../../../../../../../components/buttons/IconButtons';
import { colors } from '../../../../../../../enums/colors';
import PayrollLinesColumn, { getWidestAmount } from './PayrollLinesColumn';
import {getCalculationTypeById} from "../../../OvertimePolicies/Global/CreateUpdatePolicy/Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const DeductionsAssignedSection = ({ id }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [lines, setLines] = useState([]);

    useEffect(() => {
        if (!id) return;
        dispatch(GetDeductionByPayrollResultId(id)).then(({ payload: { data: { data, success } } }) => {
            if (success) setLines(data ?? []);
        });
    }, [id]);

    const total = lines.reduce((sum, item) => sum + (item?.amount ?? 0), 0);
    const widest = getWidestAmount(lines, 'amount', total);

    return (
        <div className='row'>
            <PayrollLinesColumn
                title={t('deductions')}
                lines={lines}
                getName={(item) => item.deductionNameSnapshot}
                getAmount={(item) => item.amount}
                widest={widest}
                total={total}
                titleIcon={<IconGraphDown fill={colors.errorCode700}/>}
                chipColors={{ background: colors.errorCode100, fontColor: colors.errorCode700, borderColor: colors.errorCode150 }}
                className='col-12 px-1'
                getLegend={(item) => `- ${getCalculationTypeById(item.deductionCalculationTypeSnapshot)?.prefixText}${item.deductionValueSnapshot}`}
            />
        </div>
    );
};

export default DeductionsAssignedSection;
